import { useState } from 'react';

import SideNavHeader from 'common/components/layouts/SideNav/SideNavHeader';
import SideNavContent from 'common/components/layouts/SideNav/SideNavContent';

interface MobileMenuContentProps {
  showMenu: boolean;
  closeMenu: () => void;
}

export const MobileMenuContent = ({ showMenu, closeMenu }: MobileMenuContentProps) => {
  const [expanded, setExpanded] = useState<string>('');

  const closeSidebar = () => {
    closeMenu();
  };

  return (
    <div className="mobile-menu-content">
      <SideNavHeader />

      <SideNavContent
        isSidebarOpen={showMenu}
        expanded={expanded}
        setExpanded={setExpanded}
        closeSidebar={closeSidebar}
      />
    </div>
  );
};
